import { ReactNode } from 'react';
import { classNames } from '../../utils/helpers';

interface CardProps {
  children: ReactNode;
  className?: string;
  /** Optional header row */
  title?: ReactNode;
  actions?: ReactNode;
  /** Remove inner padding (e.g. when embedding a table) */
  flush?: boolean;
}

export default function Card({ children, className = '', title, actions, flush }: CardProps) {
  return (
    <div className={classNames('bg-white rounded-xl border border-gray-200 shadow-card', className)}>
      {(title || actions) && (
        <div className="flex items-center justify-between gap-3 px-5 py-3.5 border-b border-gray-100">
          {title && <h3 className="text-md font-semibold text-navy">{title}</h3>}
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
      )}
      <div className={flush ? '' : 'p-5'}>{children}</div>
    </div>
  );
}
